import React from 'react';
import { getZoom } from 'shared/utils/appHelpers';
import useWindowSizes from 'shared/hooks/useWindowSizes';
import { useLocation } from 'react-router';
import Footer from 'app/routes/Landing/components/Footer';
import Header from 'app/routes/Landing/components/Header';

const PublicWrapper = ({ children }) => {
  const [width] = useWindowSizes();
  const location = useLocation();
  const page = location.pathname === '/' ? 'landing' : location.pathname.replace('/', '');

  return (
    <div style={{ zoom: getZoom(width) }} className={`wrapper on-page-${page}`}>
      <Header />
      <div className='main-content d-flex flex-column'>{children}</div>
      <Footer />
    </div>
  );
};

export default PublicWrapper;
